<template>
  <!--限时抢购页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    @refresh="refreshInit"
    infiniteScroll
    @scroll="watchScroll"
    class="limited-bg"
    style="background: #ffffff;"
    ref="limitedTimeSnapping"
    @loadingMore="getLimitedTimeSnapping"
    :style="`background-image: url(${bgSrc}) !important`"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="!isHeaderColor" :icon-name="'return'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }">限时抢购</div>
    </gradient-header>
    <!--背景图渲染-->
    <div style="padding-top: 60px;">
      <!--推荐单个商品-->
      <div class="m-t-20 m-x-10" v-if="recommendCommodity">
        <card :height="50" :width="100" class="p-0">
          <limited-time-single
            class="p-x-12 p-y-8"
            :commodity="recommendCommodity"
            :width="105"
            :height="105"
            :selling-show="true"
            :is-recommend="true"
          ></limited-time-single>
        </card>
      </div>
      <!--时间到期提示-->
      <tk-flex
        column center
        class="m-t-8 font-14"
        v-if="timeRule"
        style="color: #FFFAE2;"
      >
        <div>活动时间 {{timeRule.startTime | dateMounth}} 至 {{timeRule.endTime | dateMounth}}</div>
        <div class="font-12 m-t-8 limited-bg-tips">疯狂抢购中</div>
      </tk-flex>
      <!--列表展示-->
      <template v-if="limitedTimeSnapping.length">
        <div
          class="m-t-8 m-x-10"
          v-for="(s, index) in limitedTimeSnapping"
          :key="index"
        >
          <card :height="100" :width="100" class="p-0">
            <limited-time-single
              class="p-x-12 p-y-8"
              :commodity="s"
              :width="105"
              :height="105"
              :selling-show="false"
              :is-recommend="false"
            ></limited-time-single>
          </card>
        </div>
      </template>
    </div>
  </tk-container>
</template>

<script>
import limitedTimeSingle from '@/components/limitedTimeSingle'
export default {
  components: {
    limitedTimeSingle
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      checkDisabled: false, // 签到按钮状态
      themeBackground: null, // 主题背景图片
      limitedTimeSnapping: [], // 限时抢购数据
      recommendCommodity: null, // 推荐的商品
      timeRule: {} // 限时抢购时间规则
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  mounted () {
    this.getInit()
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 装饰图src
    decorationSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.decoration)) { return '' }
      return this.themeBackground.decoration
    }
  },
  methods: {
    /**
    * 数据初始化
    * @date: 2020/4/11
    */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getSingleSnapping() // 按销量推荐单个商品
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.limitedTimeSnapping = []
      await this.getInit()
      this.$refs.getLimitedTimeSnapping.resetInfiniteScroll()
    },
    /**
     * 获取主题图片
     * @date: 2020/4/11
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'limitedTimeSnapping'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/4/11
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 限时抢购数据获取
     * @date: 2020/3/20
     */
    async getLimitedTimeSnapping (page, next) {
      let limitedTimeSnapping = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          // order: '-createdAt',
          order: 'weight,-updatedAt',
          where: {
            shelvesStatus: 'shelves',
            typeActivity: 'panicBuying'
          }
        }
      })
      if (limitedTimeSnapping.length) {
        limitedTimeSnapping = limitedTimeSnapping.map(s => {
          if (this.isTerminalAccount) {
            s.oldPrice = s.terminalPrice
            s.price = s.activityTerminalPrice
          } else {
            s.oldPrice = s.countyPrice
            s.price = s.activityCountyPrice
          }
          return s
        })
      }
      this.limitedTimeSnapping = [...this.limitedTimeSnapping, ...limitedTimeSnapping]
      if (limitedTimeSnapping.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
    * 按销量推荐单个限时抢购商品
    * @date: 2020/4/11
    */
    async getSingleSnapping () {
      if (!this.limitedTimeSnapping.length) { return }
      let arr = this.$tkHelper.deepClone(this.limitedTimeSnapping)
      let newArr = arr.sort((a, b) => {
        if (!a.sales) { a.sales = 0 }
        if (!b.sales) { b.sales = 0 }
        return b.sales - a.sales
      })
      this.recommendCommodity = newArr[0]
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .limited-bg {
    width: 100%;
    min-height: 500px;
    background-repeat: no-repeat !important;
    background-size: 100% auto !important;
    background-attachment: fixed;
    .limited-bg-tips {
      width: 100px;
      height: 20px;
      background: rgba(255, 146, 25, 1);
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
    }
    .limited-bg-footer {
      height: 60px;
      text-align: center;
      line-height: 60px;
    }
  }
</style>
